export interface createRoles{
    nombre: string
}

export class createRoles implements createRoles{
    constructor(init?:createRolesFormValues){
        Object.assign(this,init);
    }
}

export class createRolesFormValues{
    nombre: string = ""

    constructor(createRoles?:createRolesFormValues){
        if(createRoles){
            this.nombre=createRoles.nombre
        }
    }
}

export interface listPermisos{
    id: number
    permiso: string
}

export class listPermisos implements listPermisos{
    constructor(init?:listPermisosFormValues){
        Object.assign(this,init);
    }
}

export class listPermisosFormValues{
    id: number = 0
    permiso: string=""

    constructor(listPermisos?:listPermisosFormValues){
        if(listPermisos){
            this.id=listPermisos.id
            this.permiso = listPermisos.permiso
        }
    }
}

export interface listRoles{
    id: number
    name: string
}

export class listRoles implements listRoles{
    constructor(init?:listRolesFormValues){
        Object.assign(this,init);
    }
}

export class listRolesFormValues{
    id: number = 0
    name: string=""

    constructor(listRoles?:listRolesFormValues){
        if(listRoles){
            this.id=listRoles.id
            this.name = listRoles.name
        }
    }
}

export interface createPermisostoRol{
    rolId: string
    permisos: number[]
}

export class createPermisostoRol implements createPermisostoRol{
    constructor(init?:createPermisostoRolFormValues){
        Object.assign(this,init);
    }
}

export class createPermisostoRolFormValues{
    rolId: string = ""
    permisos: number[] = []

    constructor(createPermisostoRol?:createPermisostoRolFormValues){
        if(createPermisostoRol){
            this.rolId=createPermisostoRol.rolId
            this.permisos = createPermisostoRol.permisos
        }
    }
}

export interface listPermisosByRole{
    id: number
    rolId: string
    name: string
    is_active: boolean
}

export class listPermisosByRole implements listPermisosByRole{
    constructor(init?:listPermisosByRoleFormValues){
        Object.assign(this,init);
    }
}

export class listPermisosByRoleFormValues{
    rolId: string = ""
    id: number = 0
    name: string = ""
    is_active: boolean = true

    constructor(listPermisosByRole?:listPermisosByRoleFormValues){
        if(listPermisosByRole){
            this.rolId=listPermisosByRole.rolId
            this.id = listPermisosByRole.id
            this.name = listPermisosByRole.name
            this.is_active = listPermisosByRole.is_active
        }
    }
}